// This files shared the UI config about routes
// TODO: Try a better solution to share UI behaviour...
import { matchPath } from 'react-router-dom'

export const noToolbarPaths = [
  //{ path: '/messages', exact: false },
  // { path: '/register' },
]

export const noShrinkPaths = [
  { path: '/item/:id' },
  { path: '/me/items/owned' },
  { path: '/me/items/wanted' },
  { path: '/user/:userId' },
  { path: '/messages' },
  { path: '/category' },
  { path: '/world' },
  { path: '/me/items/can-get' },
]

export const noShrinkNoToolbarPaths = [
  { path: '/notifications' },
  { path: '/add' },
  { path: '/me/ecoins' },
  { path: '/me/swaps' },
  { path: '/swap/:id' },
  { path: '/login' },
  { path: '/register' },
  { path: '/password-recover' },
  { path: '/profile' },
  { path: '/settings/profile' },
  { path: '/swap/new/:destinatarioId' },
  { path: '/swap/:id' },
  { path: '/add' },
  { path: '/help' },
  { path: '/scarica-app' },
  { path: '/come-funziona' },
  { path: '/pieghi-di-libri' },
  { path: '/accept-new-terms' },
]

export const zendeskPaths = [
  { path: '/', exact: true },
  { path: '/come-funziona' },
  { path: '/pieghi-di-libri' },
]

// Stupid shortcut
export const matchSomePaths = (pathname, paths) =>
  paths.some(p => matchPath(pathname, p))



// WEBPACK FOOTER //
// ./src/routes.js